import * as React from "react";

import { cn } from "@/lib/utils";

function Input({ className, type, ...props }: React.ComponentProps<"input">): React.ReactElement {
  // Check if className contains custom padding classes
  const hasCustomPaddingLeft = className?.includes('pl-');
  const hasCustomPaddingRight = className?.includes('pr-');
  const hasCustomPaddingX = className?.includes('px-');
  
  // Only apply default px-3 if no custom padding is specified
  const defaultPadding = !hasCustomPaddingLeft && !hasCustomPaddingRight && !hasCustomPaddingX ? 'px-3' : '';
  
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground h-9 w-full min-w-0 rounded-md border bg-white dark:bg-black py-1 text-base transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium md:text-sm dark:border-input",
        defaultPadding,
        "disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-muted/50 disabled:text-muted-foreground disabled:border-border/50",
        "read-only:bg-muted/50 read-only:text-[color:var(--readonly-foreground)] dark:read-only:text-muted-foreground read-only:cursor-default read-only:border-border/50 read-only:focus-visible:ring-0 read-only:focus-visible:border-border/50",
        "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]",
        "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
        className,
      )}
      {...props}
      data-oid="w1yhr3k"
    />
  );
}

export { Input };
